import { Star, Quote } from "lucide-react";

export function TestimonialCard({ t }) {
  const sourceLabel = { tiktok: "TikTok", instagram: "Instagram", google: "Google Review", customer: "Verified customer" }[t.source] || "Customer";
  const sourceColor = { tiktok: "text-black", instagram: "text-[#DD2A7B]", google: "text-[#4285F4]", customer: "text-[#D32F2F]" }[t.source] || "text-[#1A1A1A]";
  const rating = t.rating || 5;
  return (
    <div className="bg-white border border-[#E5D8C1] p-6 md:p-7 flex flex-col hover:border-[#D32F2F] transition-colors" data-testid={`testimonial-${t.id}`}>
      <Quote className="text-[#D32F2F]/30" size={28} />
      <p className="text-[#1A1A1A] mt-3 leading-relaxed text-[15px]">&ldquo;{t.quote}&rdquo;</p>
      <div className="mt-auto pt-6 flex items-end justify-between gap-3">
        <div>
          <div className="font-heading uppercase tracking-wide text-sm">{t.author}</div>
          <div className={`text-[10px] uppercase tracking-widest ${sourceColor} font-heading mt-1`}>{sourceLabel}</div>
        </div>
        <div className="flex text-[#FFB300]">
          {Array.from({ length: rating }).map((_, i) => <Star key={i} size={12} fill="currentColor" strokeWidth={0} />)}
        </div>
      </div>
    </div>
  );
}
